import { connectRouter } from 'connected-react-router'
import { combineReducers } from 'redux'
import { polyglotReducer } from 'redux-polyglot/dist/reducer'
import settings from './settings/reducers'


/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default history => combineReducers({
  router: connectRouter(history),
  polyglot: polyglotReducer,
  settings,
})
